const SkipLink = () => {

	document.querySelector(".skip-link").addEventListener("click", (e) => {
		e.preventDefault();
		const mainContent = document.getElementById("main-content");
		if(mainContent) {
			mainContent.focus();
			mainContent.scrollIntoView({ block: 'start' });
		}
	});
}

export default SkipLink;